module.exports = __webpack_public_path__ + "fonts/DidotLH-Italic.cc7edd27.eot";